/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { Fade } from 'react-awesome-reveal';

import heroPortfolio from 'assets/images/hero/portfolioHero.png';

export default function HeroPortfolio() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Slanted Background */}
      <div
        className="absolute inset-0 bg-theme-purple"
        style={{
          clipPath: 'polygon(0 0, 100% 10%, 100% 100%, 0 100%)',
        }}
      />

      {/* Content Section */}
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col sm:flex-row sm:items-center lg:items-start py-36 px-5 sm:px-12">
        
        {/* Left Column */}
        <div className="w-full sm:w-1/2 flex flex-col mb-10 sm:mb-0">
          <Fade direction="up" triggerOnce>
            <h1 className="text-5xl sm:text-6xl text-white font-bold leading-tight pt-20 mb-5">
              About Us
            </h1>
          </Fade>
          <Fade direction="up" triggerOnce delay={400}>
            <p className="font-light text-lg sm:text-xl text-white leading-relaxed">
              A trusted platform connecting independent directors and companies for stronger boards.
            </p>
          </Fade>
        </div>

        {/* Right Column - Image */}
        <div className="w-full sm:w-3/4 ">
          <Fade direction="up" triggerOnce>
            <img src={heroPortfolio} alt="Hero" className="w-full" />
          </Fade>
        </div>
      </div>
    </section>
  );
}
